import * as gfunctions from './generalFunctions';

CCL.login = {
  autoload: [
    ['loginAPICall', $('.login-form').length > 0]
  ],

  loginAPICall() {
    $('.login-form').submit((event) => {
      event.preventDefault();
      gfunctions.showLoader();
      const dataObj = {
        username: $('#username').val(),
        password: $('#password').val(),
        cookieless: false
      };
      const loginCall = $.ajax({
        type: 'POST',
        url: 'https://dev.bookedguest.com/cclcommercewebservices/v2/ccl/user/login',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(dataObj)
      });

      loginCall.done((response) => {
        gfunctions.hideLoader();
        const message = response.success === false ? 'Authentication Failed' : 'Authentication Sucess';
        $('.login-form-callback').text(message);
      });

      loginCall.fail(() => {
        gfunctions.hideLoader();
        console.log('Something went wrong');
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/js/login.js